module.exports = __webpack_public_path__ + "img/camera-micophone-blocked.07506546.png";